// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"85d625b6","134":"91680ff0","230":"19411460","307":"71231a9f","376":"add5fcc6","771":"050c2d98","992":"b88e0733"}[chunkId] + ".chunk.js";
};